// 서비스 워커 등록/해제
// production 빌드에서만 등록된다.

export function register() {
  if (process.env.NODE_ENV !== 'production') return;
  if (!('serviceWorker' in navigator)) return;

  window.addEventListener('load', () => {
    const swUrl = '/service-worker.js';
    navigator.serviceWorker
      .register(swUrl)
      .then((registration) => {
        // 새 버전 감지 시 자동 활성화
        registration.addEventListener('updatefound', () => {
          const installing = registration.installing;
          if (!installing) return;
          installing.addEventListener('statechange', () => {
            if (installing.state === 'installed' && navigator.serviceWorker.controller) {
              // 새 SW 설치 완료 → 즉시 활성화 요청
              registration.waiting && registration.waiting.postMessage('SKIP_WAITING');
            }
          });
        });
      })
      .catch((err) => {
        console.error('Service Worker 등록 실패:', err);
      });

    // 컨트롤러 교체되면 자동 새로고침
    let refreshing = false;
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (refreshing) return;
      refreshing = true;
      window.location.reload();
    });
  });
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then((registration) => registration.unregister())
      .catch(() => {});
  }
}
